import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OccEndpointsService } from "@spartacus/core";
import { BehaviorSubject, Observable, of, ReplaySubject } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { KnBrCheckoutService } from "../services/kn-br-checkout-service";
import { customCheckoutConfig } from "./checkout-config";

@Injectable({ providedIn: "root" })
export class CheckoutFlowService {
  private cartData$ = new ReplaySubject<any>(1); // ✅ Store full cart once loaded
  public mode$ = new BehaviorSubject<string | null>(null);
  private selectedDateSubject = new BehaviorSubject<string | null>(null);
  selectedDate$ = this.selectedDateSubject.asObservable();

  cartHasCreditCardInfo$ = new BehaviorSubject<boolean>(false);
  cartCreditInfo$ = this.cartHasCreditCardInfo$.asObservable();

  constructor(
    private http: HttpClient,
    protected endPointService: OccEndpointsService,
    protected checkoutService: KnBrCheckoutService
  ) {}

  setSelectedDate(date: string): void {
    this.selectedDateSubject.next(date);
  }

  setCreditCardPaymentSuccess(value: boolean) {
    this.cartHasCreditCardInfo$.next(value);
  }

  // fetches cart data
  fetchAndSetModeFromApi(): Observable<any> {
    return this.checkoutService.getCartApiUrl().pipe(
      switchMap((cartUrl) => this.http.get(cartUrl)),
      tap((response: any) => {
        this.cartData$.next(response);

        const deliveryMode = response.deliveryMode?.code ?? "pickUp";
        this.setMode(deliveryMode);
      }),
      catchError(() => {
        const fallback = "pickUp";
        this.setMode(fallback);
        return of(fallback);
      })
    );
  }

  getCart(): Observable<any> {
    return this.cartData$.asObservable();
  }

  setMode(mode: string) {
    localStorage.setItem("deliveryMode", mode);
    this.mode$.next(mode);
  }

  getMode(): string {
    return this.mode$.getValue() ?? "pickUp";
  }

  getConfigForMode(mode: string) {
    return customCheckoutConfig[mode];
  }

  markCompleted(mode: string, routeName: string) {
    const key = `${mode}CompletedSteps`;
    const steps = JSON.parse(localStorage.getItem(key) || "[]");
    if (!steps.includes(routeName)) {
      steps.push(routeName);
      localStorage.setItem(key, JSON.stringify(steps));
    }
  }

  getCompletedSteps(mode: string): string[] {
    const key = `${mode}CompletedSteps`;
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }

  resetProgress(mode: string) {
    const key = `${mode}CompletedSteps`;
    localStorage.removeItem(key);
  }
}
